import { Component, effect, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalCardComponent } from '@components/Modals/modal-card/modal-card.component';
import { SvgComponent } from '@components/svg.component';

@Component({
  selector: 'app-modal-invite-guests',
  standalone: true,
  imports: [ReactiveFormsModule, ModalCardComponent, SvgComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-invite-guests.component.html',
})
export class ModalInviteGuestsComponent {
  #fb = inject(FormBuilder);

  title = input.required<string>();
  subtitle = input<string | null>(null);
  countLabel = input.required<string>();
  maxCount = input.required<number>();
  initialCount = input<number>(1);
  requiredErrorMessage = input<string | null>(null);
  commentLabel = input.required<string>();
  commentPlaceholder = input<string | null>(null);
  initialComment = input<string>('');
  commentRequiredErrorMessage = input<string | null>(null);
  cancelLabel = input.required<string>();
  confirmLabel = input.required<string>();

  cancelClick = output<void>();
  confirmClick = output<{ count: number; comment: string }>();

  form = this.#fb.nonNullable.group({
    count: [1, [Validators.required, Validators.min(1)]],
    comment: ['', [Validators.required]],
  });

  constructor() {
    effect(() => {
      const { count, comment } = this.form.controls;
      count.setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(this.maxCount()),
      ]);
      count.setValue(this.initialCount());
      comment.setValue(this.initialComment());
    });
  }

  onConfirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.confirmClick.emit(this.form.getRawValue());
  }

  increment(): void {
    const current = this.form.controls.count.value;
    if (current < this.maxCount()) {
      this.form.controls.count.setValue(current + 1);
    }
  }

  decrement(): void {
    const current = this.form.controls.count.value;
    if (current > 1) {
      this.form.controls.count.setValue(current - 1);
    }
  }
}
